import alert from '@/plugins/alert'
import { Lead } from '@/plugins/api'

export default {
  namespaced: true,
  state: {
    lead: {},
    count: 0
  },
  actions: {
    async fetchLead ({ commit }, leadId) {
      commit('setLead', await Lead.fetchOne(leadId))
    },
    // api is create or update. If record exist then create.
    async createLead ({ commit }, { data, options }) {
      commit('setLead', await Lead.create(data, options))
      alert.success('Cập nhật thành công!')
    },
    async removeLead ({ commit }, id) {
      await Lead.remove(id)
      commit('removeLead', id)
      alert.success('Xóa thành công!')
    },
    setLead ({ commit, state }, lead) {
      commit('setLead', lead)
    },
    async updateLead ({ commit, state }, { id, ...lead }) {
      try {
        commit('setLead', await Lead.update(id, lead))
        alert.success('Cập nhật thành công!')
      } catch (e) {
        alert.error(e)
      }
    }
  },
  mutations: {
    setLead (state, lead) {
      state.lead = lead
    }
  },
  getters: {
    lead: (state) => {
      return state.lead
    }
  }
}
